import React from 'react';

class Enquiry extends React.Component{

    render(){
        return (
        <div>问询</div>
    )
    }
}

export default Enquiry;